import { createRootRoute, createRoute, lazyRouteComponent, Outlet } from "@tanstack/react-router";

import { AppAccess } from "../app/AppAccess";
import { AppShell } from "../app/AppShell";

export const rootRoute = createRootRoute({
  component: Outlet,
  notFoundComponent: lazyRouteComponent(() => import("../app/pages/NotFoundPage"), "NotFoundPage"),
});

export const appLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "app",
  component: () => (
    <AppAccess>
      <AppShell />
    </AppAccess>
  ),
});
